import en from './en.json';
import pt from './pt.json';

export default { en, pt };

export type Language = 'en' | 'pt';
export type IntlMessages = Record<Language, Record<string, string>>;

const intlMessages: IntlMessages = { en, pt };

export const getMessages = (locale: Language) => intlMessages[locale] || intlMessages.pt;
